export const SHARE_MODAL_TABS = {
  SHARE: 'share',
  NOTIFICATION: 'notification',
};

export const SHARE_MODAL_TAB_LABELS: Record<string, string> = {
  [SHARE_MODAL_TABS.SHARE]: 'Share View(s) via Email',
  [SHARE_MODAL_TABS.NOTIFICATION]: 'Manually Send Email Notification',
};
